import React from 'react';
import './AddIngredientModal.css';
import { HexColorPicker } from 'react-colorful';

const EditIngredientModal = ({ isOpen, onClose, onSubmit, ingredient, handleInputChange, handleFileChange, categories }) => {

    if (!isOpen) return null;

    const handleColorChange = (color) => {
        // Create a synthetic event object to work with your existing handleInputChange
        const event = {
            target: {
                name: 'color',
                value: color,
                type: 'text'
            }
        };
        handleInputChange(event);
    }

    return (
        <div className="modal">
            <div className="modal-content-ingredient-management">
                <span className="close-button" onClick={onClose}>&times;</span>
                <h2>Edit Ingredient</h2>
                <p className="modal-description">Update the ingredient details below</p>
                <form onSubmit={onSubmit} className="add-ingredient-form">
                    <div className="form-group">
                        <label htmlFor="name">Ingredient Name</label>
                        <p className="field-description">Enter the name of the ingredient</p>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={ingredient.name}
                            onChange={handleInputChange}
                            placeholder="Enter ingredient name"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="description">Description</label>
                        <p className="field-description">Enter a description for the ingredient (optional)</p>
                        <textarea
                            id="description"
                            name="description"
                            value={ingredient.description || ''}
                            onChange={handleInputChange}
                            placeholder="Enter description"
                            rows={3}
                            style={{ width: '100%', padding: '6px', borderRadius: '4px', border: '1px solid #ccc' }}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="category">Category</label>
                        <p className="field-description">Select or enter the ingredient category</p>
                        <select
                            id="category"
                            name="categoryId"
                            value={ingredient.categoryId}
                            onChange={handleInputChange}
                            required
                        >
                            <option value="">Select a category</option>
                            {categories.map(category => (
                                <option key={category.categoryId} value={category.categoryId}>
                                    {category.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="unitPrice">Price (NOK)</label>
                        <p className="field-description">Enter the price per unit in Norwegian Krone</p>
                        <input
                            type="number"
                            id="unitPrice"
                            name="unitPrice"
                            value={ingredient.unitPrice}
                            onChange={handleInputChange}
                            placeholder="Enter price"
                            min="0"
                            step="0.01"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="fillLevel">Fill Level (%)</label>
                        <p className="field-description">Enter the current fill level percentage (0-100)</p>
                        <input
                            type="number"
                            id="fillLevel"
                            name="fillLevel"
                            value={ingredient.fillLevel || 0}
                            onChange={handleInputChange}
                            placeholder="Enter fill level"
                            min="0"
                            max="100"
                            step="1"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="color">Ingredient Color</label>
                        <p className="field-description">Pick any color using the wheel or hex:</p>

                        <div className="color-picker-main-container">
                            {/* Color preview */}
                            <div className="color-preview-large"
                                style={{
                                    backgroundColor: ingredient.color || '#CCCCCC',
                                    width: '100%',
                                    height: '40px',
                                    borderRadius: '4px',
                                    border: '1px solid #ddd',
                                    marginBottom: '10px'
                                }}
                            />

                            {/* Color Wheel Picker */}
                            <HexColorPicker
                                color={ingredient.color || '#CCCCCC'}
                                onChange={handleColorChange}
                                style={{ width: '100%', marginBottom: '10px' }}
                            />

                            {/* Optional manual hex input */}
                            <input
                                type="text"
                                name="color"
                                value={ingredient.color || ''}
                                onChange={handleInputChange}
                                placeholder="#RRGGBB"
                                style={{ width: '100%', padding: '6px', borderRadius: '4px', border: '1px solid #ccc' }}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="isAvailable">Available</label>
                        <input
                            type="checkbox"
                            id="isAvailable"
                            name="isAvailable"
                            checked={ingredient.isAvailable}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="imageFile">Upload New Image</label>
                        <p className="field-description">Upload a new image for the ingredient (optional)</p>
                        <input
                            type="file"
                            id="imageFile"
                            name="imageFile"
                            onChange={handleFileChange}
                            accept="image/*"
                        />
                    </div>
                    <div className='modal-actions'>
                        <button type="submit" className="add-button">Save Changes</button>
                        <button type="button" className="cancel-button-ingredient-management" onClick={onClose}>Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditIngredientModal;